import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
//import { Appointment } from '/types/appointment';
import { AppointmentCard } from './AppointmentCard';


export function DraggableAppointment({ appointment, compact = false }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: appointment.id,
    data: { appointment },
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 50 : 'auto',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className="draggable"
    >
      <AppointmentCard appointment={appointment} compact={compact} />
    </div>
  );
}
